var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGenderDiversity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Multiple-Man-Woman-4--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Multiple Man Woman 4 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 0a4.21 4.21 0 1 0 4.2 4.2A4.21 4.21 0 0 0 17 0Zm0 6.43a2.23 2.23 0 0 1 -2.28 -2.23 2.06 2.06 0 0 1 0.16 -0.79 0.28 0.28 0 0 1 0.12 -0.15 0.26 0.26 0 0 1 0.21 0 5.32 5.32 0 0 0 2.8 0.79 5.47 5.47 0 0 0 0.9 -0.08 0.18 0.18 0 0 1 0.16 0 0.18 0.18 0 0 1 0.07 0.15A2.22 2.22 0 0 1 17 6.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.39 14.11a5.44 5.44 0 0 0 -8.79 -4.29 0.5 0.5 0 0 0 -0.17 0.56c0.3 0.85 0.61 2 1.08 3.75 0.24 0.9 0.53 2 0.89 3.27a2.54 2.54 0 0 1 -0.4 2.18 2.33 2.33 0 0 1 -0.53 0.51 0.48 0.48 0 0 0 -0.21 0.45l0.25 3A0.49 0.49 0 0 0 15 24h4a0.5 0.5 0 0 0 0.49 -0.45l0.44 -5.26a0.25 0.25 0 0 1 0.24 -0.23h1.8a0.49 0.49 0 0 0 0.49 -0.49Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71 18.36a0.5 0.5 0 0 0 0.39 0.2h2.3a0.26 0.26 0 0 1 0.25 0.2l0.92 4.84a0.49 0.49 0 0 0 0.48 0.4H9a0.51 0.51 0 0 0 0.49 -0.4l0.92 -4.84a0.24 0.24 0 0 1 0.24 -0.2H13a0.5 0.5 0 0 0 0.39 -0.2 0.48 0.48 0 0 0 0.09 -0.43c-2 -7.16 -1.88 -7.55 -3 -8.6a0.5 0.5 0 0 0 -0.76 0.1L8 12.16a0.5 0.5 0 0 1 -0.84 0L5.41 9.41a0.52 0.52 0 0 0 -0.36 -0.23 0.5 0.5 0 0 0 -0.4 0.13c-1.15 1.06 -1.06 1.47 -3 8.62a0.47 0.47 0 0 0 0.06 0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32 4.21A4.21 4.21 0 1 0 7.53 0a4.21 4.21 0 0 0 -4.21 4.21Zm4.21 2.22a2.23 2.23 0 0 1 -2.14 -1.62 0.24 0.24 0 0 1 0.16 -0.3 4.7 4.7 0 0 0 1.8 -1.13 0.22 0.22 0 0 1 0.17 -0.07 0.24 0.24 0 0 1 0.18 0.07 4.7 4.7 0 0 0 1.8 1.13 0.24 0.24 0 0 1 0.16 0.3 2.21 2.21 0 0 1 -2.13 1.62Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGenderDiversity);
export default ForwardRef;